import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ja from './ja.json';
export const resources = {
    en: {
        translation: en,
    },
    ja: {
        translation: ja,
    }
};

const queryParams = new URLSearchParams(window.location.search);
const spLanguage = queryParams.get('SPLanguage') || 'en';

i18n.use(initReactI18next).init({
    lng: spLanguage,
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true, // Allow short lang names eg. en-US = en
    resources,
});

export default i18n;
